export function pageLanguage()
{
  if(!document.documentElement || !document.documentElement.lang) {
    return 'it';
  }

  let lang = document.documentElement.lang.substring(0, 2);

  return lang;
}


// WEBPACK FOOTER //
// ./scripts/util/common.js